import React, { useState, useEffect, useRef } from 'react';
import "./Style/SysAdminLogin.css";
import bg from "./Image/login_bg2.jpg";
import Loading from '../Common/Loading';

const SysAdminLogin: React.FC = () => {
  const [loginID, setLoginID] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [selectedMSR, setSelectedMSR] = useState<string>('0');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [siteName, setSiteName] = useState<string>('STAGING');
  const [utcTime, setUtcTime] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 1920);
  const loginIDRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  document.body.style.backgroundImage = `url(${bg})`;
  document.body.style.backgroundSize = "cover";
  document.body.style.backgroundRepeat = "no-repeat";
  document.body.style.backgroundPosition = "center";

  const API_BASE = process.env.REACT_APP_DOCUMENT_LINK || 'https://staging.sysadmin.elearnoncloud.com/';
  useEffect(() => {
    if (loginIDRef.current) {
      loginIDRef.current.focus();
    }

    const now = new Date();
    setUtcTime(now.toUTCString().replace("GMT", "UTC"));

    if (window.location.host.includes("sysadmin.elearnoncloud.com")) {
      const hostname = window.location.hostname;

      if (
        hostname === "sysadmin.elearnoncloud.com" ||
        hostname === "www.elearnoncloud.com"
      ) {
        setSiteName("PRODUCTION");
      } else if (hostname === "staging.sysadmin.elearnoncloud.com") {
        setSiteName("STAGING");
      } else {
        setSiteName("TESTING");
      }

      const savedLoginID = localStorage.getItem("UserName");
      const savedPassword = localStorage.getItem("Password");

      if (savedLoginID && savedPassword) {
        setLoginID(savedLoginID);
        setPassword(savedPassword);
        setRememberMe(true);
      }
    }
  }, []);
  // Responsive: track window width so inline styles can react to breakpoints
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 600;
  const isSmallMobile = windowWidth <= 425;
  const isTablet = windowWidth <= 800;
  const isNarrow = windowWidth <= 1100;

  const handleLogin = async (e: React.FormEvent | React.KeyboardEvent) => {
    e.preventDefault();

    if (!loginID || !password) {
      setErrorMessage('Please enter your login ID and password');
      flashText();
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}api/login/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          login: loginID,
          password,
          schoolCode: 'A',
          familyCode: 'AA',
          msrType: selectedMSR,
        }),
      });

      const data = await response.json();

      // VB: password OK but OTP required -> Remember Me is written first, then redirect to OTP.aspx
      if (response.ok && data.otpRequired) {
        if (rememberMe) {
          localStorage.setItem('UserName', loginID);
          localStorage.setItem('Password', password);
        } else {
          localStorage.removeItem('UserName');
          localStorage.removeItem('Password');
        }
        sessionStorage.setItem('OTP_TOKEN', data.otpToken);
        sessionStorage.setItem('OTP_MASKED_EMAIL', data.maskedEmail || '');
        window.location.href = '/SysAdmin/OTP';
        return;
      }

      if (response.ok) {
        sessionStorage.setItem("MENU_RIGHTS", data.newpermissions);
        sessionStorage.setItem("S", "A");
        sessionStorage.setItem("F", "AA");
        sessionStorage.setItem("L", loginID);
        sessionStorage.setItem("Password", password);
        sessionStorage.setItem('UserName', loginID);
        sessionStorage.setItem('Password', password);
        sessionStorage.setItem("access_token", data.access);
        sessionStorage.setItem("refresh_token", data.refresh);

        if (rememberMe) {
          localStorage.setItem('UserName', loginID);
          localStorage.setItem('Password', password);
        } else {
          localStorage.removeItem('UserName');
          localStorage.removeItem('Password');
        }

        // window.location.href = selectedMSR === '0' ? '/SysAdmin' : '/SYSADMIN/Dashboard';
        window.location.href = '/SysAdmin';
      } else {
        setErrorMessage(data.error || 'Username or Password is incorrect.');
        setLoginID('');
        setPassword('');
      }
    } catch (error) {
      setErrorMessage('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  const flashText = () => {
    const flashElement = document.querySelector('.flash') as HTMLElement;
    if (flashElement) {
      let count = 0;
      const interval = setInterval(() => {
        flashElement.style.color = count % 2 === 0 ? '#F90' : 'white';
        count++;
        if (count > 4) clearInterval(interval);
      }, 200);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <div id="main_top_container">
        <div id="header1" style={{ height: '40px', backgroundColor: "#333" }}></div>
        <div id="login_title_bar" className="section_container section_title_bar" style={{ height: isTablet ? "60px" : "80px" }}>
          <div className="section_div bar_section">
            <div
              className="title-container"
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between",
                alignItems: isMobile ? "center" : "normal",
                fontWeight: "normal",
                margin: isMobile ? "8px" : "27px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              <span
                className="bar_title"
                style={{
                  fontWeight: "normal",
                  textShadow: "1px 0px 1px #fff",
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: isSmallMobile ? "10px" : isTablet ? "12px" : undefined,
                }}
              >
                {/* DEVELOPMENT&nbsp;&nbsp;&nbsp;&nbsp;V1.9.35 - 1 */}
                DEVELOPMENT&nbsp;&nbsp;&nbsp;&nbsp;V2
              </span>
              <span
                className="bar_title"
                style={{
                  fontWeight: "normal",
                  textShadow: "1px 0px 1px #fff",
                  fontFamily: "Open Sans, sans-serif",
                  fontSize: isSmallMobile ? "10px" : isTablet ? "12px" : undefined,
                }}
              >
                {siteName}
              </span>
              {!isMobile && (
                <span
                  className="bar_title"
                  style={{
                    fontWeight: "normal",
                    textShadow: "1px 0px 1px #fff",
                    fontFamily: "Open Sans, sans-serif",
                    fontSize: isTablet ? "12px" : undefined,
                  }}
                >
                  {utcTime}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div id="login" className="section_container">
        <div id="login_logo"></div>

        <div
          id="select_msr"
          style={isMobile ? { width: '90%', maxWidth: '400px' } : undefined}
        >
          {/* <label style={{ color: 'aliceblue', fontFamily: "Open Sans, sans-serif", fontSize: isSmallMobile ? "13px" : undefined }}>
            <input
              type="radio"
              value="0"
              checked={selectedMSR === '0'}
              onChange={() => setSelectedMSR('0')}
              style={{ verticalAlign: "top" }}
            />
            Old SysAdmin (For Old MSR users)
          </label> */}

          <div style={{ height: "6px" }}></div>

          {/* <label style={{ color: 'aliceblue', fontFamily: "Open Sans, sans-serif", fontSize: isSmallMobile ? "13px" : undefined }}>
            <input
              type="radio"
              value="1"
              checked={selectedMSR === '1'}
              onChange={() => setSelectedMSR('1')}
              style={{ verticalAlign: "top" }}
            />
            <input
              type="radio"
              value="1"
              checked={false}
              disabled
              style={{ verticalAlign: "top" }}
            />
            New System Admin (For New MSR Users)
          </label> */}
        </div>

        <div id="login_form_box">
          {/* tabIndex={1}: Login ID field — Tab moves to password */}
          <input
            ref={loginIDRef}
            type="text"
            className="login_field login_userid"
            placeholder="Login ID"
            maxLength={50}
            value={loginID}
            tabIndex={1}
            onChange={(e) => setLoginID(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === 'Tab') {
                e.preventDefault();
                passwordRef.current?.focus();
              }
            }}
          />

          <div className="divider"></div>

          {/* tabIndex={2}: Password field — Enter triggers login */}
          <input
            ref={passwordRef}
            type={showPassword ? 'text' : 'password'}
            className="login_field login_password"
            placeholder="Password"
            maxLength={50}
            value={password}
            tabIndex={2}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleLogin(e);
              }
            }}
          />

          <span id="password_icon_container">
            <span
              className={`show_hide_password_icon ${showPassword ? "toggle_password" : ""}`}
              onClick={togglePasswordVisibility}
              role="button"
              tabIndex={0}
              aria-label={showPassword ? "Hide password" : "Show password"}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  togglePasswordVisibility();
                }
              }}
            >
              <span className="tooltiptext">
                {showPassword ? "Hide password" : "Show password"}
              </span>
            </span>
          </span>
          <div className="divider"></div>

          <label className="remember-me" style={{ color: 'aliceblue', fontFamily: "Open Sans, sans-serif", fontSize: isSmallMobile ? "13px" : undefined }}>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              style={{ fontFamily: "Open Sans, sans-serif" }}
            />
            Remember Me
          </label>
        </div>

        <p id="alert_text">
          <span className="flash">{errorMessage || '\u00A0'}</span>
        </p>

        <div className="button_box">
          <div id="login_btn" className="general_btn two_btn" style={{ cursor: "pointer" }}>
            {/* tabIndex={3}: Login button */}
            <button
              onClick={handleLogin}
              disabled={loading}
              tabIndex={3}
              style={{ color: "white", border: "none", boxShadow: "1px 2px 2px 1px #0e0e0e5d", cursor: "pointer", backgroundColor: "#F60" }}
            >
              Log In
            </button>
          </div>
        </div>

        <p className="page_text_sml" style={{ textAlign: "center", width: "100%", fontSize: isSmallMobile ? "13px" : "16px", margin: "0px" }}>
          <a
            // href="/LOGIN/ForgotPassword.aspx?UserType=SysAdmin"
            target="_blank"
            className="page_link"
            style={{ textAlign: "center", fontWeight: "normal", fontSize: isSmallMobile ? "13px" : "16px", textDecoration: "underline" }}
          >
            Forgotten my password
          </a>
          <span className="text_breaker"></span>
        </p>
      </div>

      {loading && <Loading />}
    </div>
  );
};

export default SysAdminLogin;
